module.exports = __webpack_public_path__ + "static/media/lend_sunold.e1c57cda.svg";